import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useMemo, useEffect } from "react";
import { useIntl } from "react-intl";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import { useCartContext } from "@magento/peregrine/lib/context/cart";
import { APPLY_COUPON_MUTATION, REMOVE_COUPON_MUTATION, GET_APPLIED_COUPONS } from "@overrides_venia/venia-ui/components/CartPage/PriceAdjustments/CouponCode/coupons.gql";
import { GET_CUSTOMER } from "../../SignIn/signIn.gql";
import { showNotification } from "@Components/Notification/Notification";
import { useExponea } from "@Src_main/utils/useExponea";
export const useCouponCode = props => {
  const [{
    cartId,
    details
  }, {
    updateCartData
  }] = useCartContext();
  const {
    trackAllEvent
  } = useExponea();
  const {
    formatMessage
  } = useIntl();
  const [applyCoupon, {
    error: applyError,
    loading: applyingCoupon
  }] = useMutation(APPLY_COUPON_MUTATION);
  const [getAvailableCoupon, {
    error: getAvailableCouponError,
    loading: getAvailableCouponLoading,
    data: availableCoupon
  }] = useLazyQuery(GET_CUSTOMER);
  const [removeCoupon, {
    error: removeCouponError,
    loading: removingCoupon
  }] = useMutation(REMOVE_COUPON_MUTATION);
  const appliedCoupon = useMemo(() => {
    var _details$applied_coup;
    return (details === null || details === void 0 ? void 0 : (_details$applied_coup = details.applied_coupons) === null || _details$applied_coup === void 0 ? void 0 : _details$applied_coup.length) > 0 ? details.applied_coupons[0].code : null;
  }, [details]);
  const handleApplyCoupon = useCallback(async (couponCode, onSuccess, onError) => {
    if (!couponCode) return;
    try {
      await applyCoupon({
        variables: _objectSpread({
          cartId
        }, couponCode),
        onCompleted: data => {
          trackAllEvent("apply_coupon", {
            coupon: couponCode
          });
          updateCartData(data.applyCouponToCart.cart);
          showNotification({
            message: formatMessage({
              id: "coupon.success.add.title"
            }),
            status: 'success',
            iconName: 'icon-check',
            iconColor: 'success',
            bold: true
          });
          if (onSuccess) onSuccess(data);
        },
        onError: error => {
          showNotification({
            message: error,
            status: 'danger',
            iconName: 'icon-info',
            iconColor: 'danger',
            bold: true
          });
          if (onError) onError(error);
        }
      });
    } catch (e) {
      if (onError) onError(e);
    }
  }, [applyCoupon, cartId]);
  const handleRemoveCoupon = useCallback(async (couponCode, onSuccess, onError) => {
    try {
      await removeCoupon({
        variables: {
          cartId
        },
        onCompleted: data => {
          trackAllEvent("remove_coupon", {
            coupon: couponCode
          });
          updateCartData(data.removeCouponFromCart.cart);
          showNotification({
            message: formatMessage({
              id: "coupon.success.remove.title"
            }),
            status: 'warning',
            iconName: 'icon-check',
            iconColor: 'warning',
            bold: true
          });
          if (onSuccess) onSuccess(data);
        },
        onError: error => {
          showNotification({
            message: error,
            status: 'danger',
            iconName: 'icon-info',
            iconColor: 'danger',
            bold: true
          });
          if (onError) onError(error);
        }
      });
      if (callback) callback();
    } catch (e) {
      if (onError) onError(e);
    }
  }, [cartId, removeCoupon]);

  // Create a memoized error map and toggle individual errors when they change
  const errors = useMemo(() => new Map([["applyCouponMutation", applyError], ["removeCouponMutation", removeCouponError]]), [applyError, removeCouponError]);
  return {
    applyingCoupon,
    appliedCoupon,
    errors,
    handleApplyCoupon,
    handleRemoveCoupon,
    removingCoupon,
    getAvailableCoupon,
    availableCoupon,
    isLoading: applyingCoupon || removingCoupon
  };
};